var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.817,
    height: 20.895,
    viewBox: "0 0 17.817 20.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7911e15e45bc4e814d791f7e7c63bde4",
    "data-name": "7911e15e45bc4e814d791f7e7c63bde4",
    transform: "translate(0.261 0.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M.739,8.621a7.909,7.909,0,1,1,15.817.054v.09c-.054,2.839-1.639,5.463-3.583,7.515a20.788,20.788,0,0,1-3.7,3.045.958.958,0,0,1-1.254,0,20.412,20.412,0,0,1-5.2-4.872,10.121,10.121,0,0,1-2.078-5.8Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "rgba(0,0,0,0.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2.535,
    cy: 2.535,
    r: 2.535,
    transform: "translate(6.112 6.238)",
    fill: "none",
    stroke: "rgba(0,0,0,0.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoction);
export default __webpack_public_path__ + "static/media/loction.bb3a3269a931df21fc6d997c9e37dd35.svg";
export { ForwardRef as ReactComponent };